import {loadStripe, Stripe} from '@stripe/stripe-js';

const STRIPE_KEY = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;

if (!STRIPE_KEY) {
  throw new Error('Could not find Stripe publishable key in environment');
}

let stripePromise: Promise<Stripe | null>;

export const getStripe = async (): Promise<Stripe | null> => {
  // Don't load stripe scripts in Lighthouse
  if (window.navigator.userAgent.match('Lighthouse')) return null;

  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_KEY);
  }

  return stripePromise;
};
